/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Use static SVG for professional appearance
};

const greeting = {
  username: "Aymen Maqsood Mulbagal",
  title: "Hi, I'm Aymen!",
  subTitle: "Aymen Maqsood, MSc | Bioinformatics Analyst I @ JustLabs\n\nI am a bioinformatics Analyst with 2+ years experience in computational biology with expertise in multi-omics research. I analyze high throughput biomedical data from complex experimental designs to study the genomics of cancer.\n\nI have a MSc in Bioinformatics and Computational Life Sciences. My technical expertise is in advanced computing, data science and statistics, UNIX-based command line tools, and programming languages like Bash, R, and Python.\n\nI work at JustLabs on the VC team developing and optimizing various Bioinformatics pipelines for our Projects.",
  resumeLink:
    "https://drive.google.com/file/d/1vKB4oWdo_KwTIEJkhml8f389xywCX96s/view?usp=sharing", // Add the link to your resume here
  displayGreeting: true
};

// Social Media Links

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/mulbagalamaq",
  linkedin: "https://www.linkedin.com/in/aymen-maqsood/",
  gmail: "aymenmaqsoodmulbagal@gmail.com",
  twitter: "https://x.com/Aymenmaq25",
  display: true
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: "Cancer genomics × scalable pipelines × machine learning.",
  skills: [
    "I build tools and workflows that turn complex sequencing data into actionable research—from CRISPR editing safety analysis to tumor classification models.",
  ],
  softwareSkills: [
    {skillName: "Python", fontAwesomeClassname: "fab fa-python"},
    {skillName: "R", fontAwesomeClassname: "fab fa-r-project"},
    {skillName: "AWS", fontAwesomeClassname: "fab fa-aws"},
    {skillName: "Docker", fontAwesomeClassname: "fab fa-docker"},
    {skillName: "Git", fontAwesomeClassname: "fab fa-git"},
    {skillName: "Jupyter", fontAwesomeClassname: "fab fa-python"},
    {skillName: "Nextflow", fontAwesomeClassname: "fas fa-code-branch"},
    {skillName: "SQL", fontAwesomeClassname: "fas fa-database"}
  ],
  display: true // No semicolon needed here, as this is the last property in this object
};

/* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

// Education Section
const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Northeastern University",
      logo: require("./assets/images/northeasternLogo.jpg"),
      subHeader: "Master of Science in Bioinformatics",
      duration: "September 2022 - December 2024",
      desc: "Focused on bioinformatics computational methods, machine learning, and genomics."
    },
    {
      schoolName: "Ramaiah Institute of Technology",
      logo: require("./assets/images/ramaiahLogo.png"),
      subHeader: "Bachelor of Engineering in Biotechnology",
      duration: "August 2018 - August 2022",
      desc: "Studied  biotechnology & engineering  fundamentals including genomics, structural biology, and biostatistics."
    }
  ]
};

// Your top 3 proficient stacks/tech experience
// Tech Stack
const techStack = {
  viewSkillBars: false,
  experience: [
    {Stack: "Bioinformatics", progressPercentage: "95%"},
    {Stack: "Machine Learning", progressPercentage: "80%"},
    {Stack: "Data Visualization", progressPercentage: "95%"}
  ]
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Bioinformatics Analyst",
      company: "JustLabs (Green Bio Compute Platform)",
      companylogo: require("./assets/images/JustLabs.jpeg"),
      date: "March 2025 – Present",
      descBullets: [
        "Developed and benchmarked bioinformatic pipelines (ATAC-seq, CITE-seq, protein-protein modeling) within the Green Bio Compute platform, analyzing runtime metrics to build predictive models for computational efficiency",
        "Designed ML models using scikit-learn and TensorFlow to forecast energy consumption patterns of lab equipment",
        "Architected a full-stack emissions platform (React, FastAPI, PostgreSQL) and a real-time analytics dashboard to monitor emission spikes across HPC clusters, reducing GPU usage by 15% and idle time by ~30%",
        "Tools & Technologies: Python, TypeScript, React"
      ]
    },
    {
      role: "Quantitative Biology & Bioinformatics Analyst Co-op",
      company: "Vor Bio",
      companylogo: require("./assets/images/vorBioLogo.png"),
      date: "July 2024 – December 2024",
      descBullets: [
        "Deployed Nextflow pipelines on AWS for CRISPR-edited NGS data for various AML targets, identifying 24 new off-target sites and reducing end-to-end analysis time by ~7 hours per sample",
        "Benchmarked open-source off-target analysis tools against in-house software to refine off-target safety profiles for AML therapies, delivering decision-ready reports that accelerated gRNA selection",
        "Performed multi-omics integration of CD33-edited HSPCs data (CITE-seq + ScRNA seq); used statistical modeling to quantifiy editing efficiency and CD33 loss across thousands of cells",
        "Tools & Technologies: R, Python, BASH, Nextflow, AWS EC2/S3, R Shiny, Bitbucket, Jira"
      ]
    },
    {
      role: "Research Associate",
      company: "Institute for Experiential AI, Northeastern University",
      companylogo: require("./assets/images/eaiLogo.jpeg"),
      date: "November 2023 – June 2024",
      descBullets: [
        "Developed reproducible bioinformatics pipelines using Snakemake and Docker on AWS/HPC environments to preprocess terabytes of ENCODE eCLIP data",
        "Trained and validated XGBoost classifiers on RNA-binding protein datasets, generating critical feature vectors that improved the accuracy of alternative splicing models",
        "Tools & Technologies: Python (Pandas, Scikit-learn), Snakemake, High-Performance Computing (SLURM), XGBoost"
      ]
    },
    {
      role: "Project Intern",
      company: "Indian Institute of Science (IISc)",
      companylogo: require("./assets/images/iiscLogo.jpeg"),
      date: "February 2022 – July 2022",
      descBullets: [
        "Engineered a systems biology framework to analyze RNA-Seq data, characterizing metabolic plasticity and hybrid E/M states in cancer metastasis under Dr. Mohit Kumar Jolly",
        "Constructed and validated a gene regulatory network (GRN) involving ELF3, miR-200, SNAIL, ZEB-1, and SLUG, identifying key topological drivers of the Mesenchymal-Epithelial Transition (MET)",
        "Simulated phenotypic distributions to elucidate the context-dependent role of lncRNA HOTAIR in modulating EMT dynamics, revealing its dual function in promoting hybrid cellular states and tumor progression",
        "Applied statistical modeling to quantify correlations between gene expression signatures and phenotypic aggressivity, providing robust molecular targets for reducing metastatic potential"
      ]
    },
    {
      role: "Laboratory Intern",
      company: "Ramaiah Advanced Testing Laboratory",
      companylogo: require("./assets/images/ramaiahLogo.png"),
      date: "June 2021 – October 2021",
      descBullets: [
        "Performed microbiological testing and analyzed sample quality for contaminants, ensuring FSSAI compliance",
        "Quantified Coliform bacteria and Staphylococcus aureus in food and water samples for safety compliance",
        "Interpreted results from LC-MS, ICP-MS, and UV spectrophotometry with high accuracy",
        "Researched contaminants in samples like chocolate and lake water, identifying 10 toxicants",
        "Skills: GLP, Analytical Biochemistry, Cell Culture, ICP-MS, PCR, UV/Vis Spectroscopy, HPLC, GMP, qPCR, Microbiology, GC-MS, LC-MS"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readm3e.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Achievements And Certifications",
  subtitle:
    "Achievements and notable associations in Bioinformatics and Biotechnology",

  achievementsCards: [
    {
      title: "Member of GeneLab's Multiomics AWG",
      subtitle: "NASA GeneLab, Jul 2024 - Present · 4 mos",
      image: require("./assets/images/nasa_genelab_logo.jpeg"), // Path to NASA GeneLab logo
      imageAlt: "NASA GeneLab Logo",
      footerLink: [
        {
          name: "NASA GeneLab",
          url: "https://genelab.nasa.gov/" // Link to NASA GeneLab page
        }
      ]
    },
    {
      title: "Head of Bioinformatics",
      subtitle:
        "Graduate Biotech and Bioinformatics Association, Northeastern University, Aug 2024 - Present",
      image: require("./assets/images/gbbaLogo.jpeg"), // Path to GBBA logo
      imageAlt: "GBBA Logo",
      footerLink: [
        {
          name: "GBBA at Northeastern",
          url: "https://www.linkedin.com/company/graduate-biotech-bioinfo-association/posts/?feedView=all" // Update with a GBBA-specific link if available
        }
      ]
    }
  ],
  display: false // Set to false to hide this section
};

// Publications Section
const publicationsSection = {
  title: "Publications",
  subtitle: "Publications and Preprints",
  googleScholarLink: "https://scholar.google.com/citations?user=8cMjNNwAAAAJ&hl=en",
  display: true
};

// Hackathon Section
const hackathonSection = {
  title: "Hackathons",
  subtitle: "Competitive Programming and Innovation Events",
  slideInterval: 6000, // milliseconds
  hackathons: [
    {
      name: "BIO IT Hackathon",
      description: "Bio-IT World Hackathon 2025",
      linkedInLink: "https://www.linkedin.com/feed/update/urn:li:activity:7314345881997119488/",
      images: [
        require("./assets/images/glycoenzyme_workflow_diagram.png"), // GlycoEnzyme Expression Atlas Workflow Diagram (or .jpg/.jpeg)
        require("./assets/images/bioit_conference_photo.png") // Bio-IT World Conference Photo (or .jpg/.jpeg)
      ]
    },
    {
      name: "AWS Open Data Knowledge Graph Hackathon",
      description: "AWS Open Data Knowledge Graph Hackathon 2025",
      linkedInLink: "https://www.linkedin.com/feed/update/urn:li:activity:7382528364034822144/",
      images: [
        require("./assets/images/aws_hackathon_group_photo.jpeg") // AWS Hackathon Group Photo
      ]
    }
  ],
  display: true
};

// Analysis Plots Section
const analysisPlotsSection = {
  title: "Example Analysis Plots",
  subtitle: "Data Visualization and Bioinformatics Analysis",
  slideInterval: 6000, // milliseconds
  categories: [
    {
      name: "Quality Control",
      images: [
        require("./assets/images/fastqc_mean_quality_scores.jpg"), // FastQC: Mean Quality Scores
        require("./assets/images/mean_dispersion_plots.png") // Mean-Dispersion Plots (Highly Variable Gene Selection)
      ]
    },
    {
      name: "Downstream Analysis Plots",
      images: [
        require("./assets/images/ridgeline_enrichment_scores.png"), // Ridgeline Plot of Enrichment Scores by Feature Type
        require("./assets/images/biological_pathway_diagram.png"), // Biological Pathway Network Diagram
        require("./assets/images/kaplan_meier_survival_curve.png"), // Kaplan-Meier Survival Curve (HOTAIR)
        require("./assets/images/ATAC_Peaks.png"), // ATAC-seq Peaks
        require("./assets/images/EOPC_association_plots.png") // EOPC Association Plots
      ]
    }
  ],
  display: true
};

export const labExperienceSection = {
  title: "Lab Experience",
  subtitle:
    "Combining hands-on biotechnology skills with a strong foundation in bioinformatics, my laboratory experience bridges experimental and computational approaches..",
  experiences: [
    {
      title: "Laboratory Techniques in Biotechnology",
      description:
        "Trained in handling microbiological cultures, quantifying bacterial presence, and performing aseptic techniques under sterile conditions. This hands-on experience has enriched my understanding of laboratory protocols and safety.",
      image: require("./assets/images/lab_work_image1.png")
    },
    {
      title: "Poster Presentation on EMT in Cancer Cells",
      description:
        "Presented research on mesenchymal-epithelial transition (MET) in cancer metastasis, applying computational simulations and gene regulatory network modeling.",
      image: require("./assets/images/poster_presentation_image.png")
    }
  ],
  display: true // Set to false if you want to hide this section
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE",

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: "Podcast",
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

// Contact Info
const contactInfo = {
  title: "Contact Me",
  subtitle: "Let's discuss bioinformatics and data science",
  email_address: "aymenmaqsoodmulbagal@gmail.com",
  number: "857-296-2150"
};

// Twitter Section

const twitterDetails = {
  userName: "Aymenmaq25", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  publicationsSection,
  hackathonSection,
  analysisPlotsSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
